const _ = require('lodash')
const partyAnswers = require('../data/partyAnswers')
const partyAlliances = require('../data/partyAlliances')

const MAX_OPINION_DIFFERENCE = .75
const MAX_WEIGHTED_OPINION_DIFFERENCE = 1.5

module.exports = function(allCandidates = {}, district, answers, weightedAnswers, filters = {}) {
  if (!allCandidates[district]) {
    return { noResults: true }
  }

  const districtPartyAlliances = partyAlliances['all'].concat(partyAlliances[district] || [])

  const opinions = answers.map(answer => {
    if (weightedAnswers && weightedAnswers.includes(answer.question)) {
      return {
        ...answer,
        answer: answer.answer * 2,
        weighted: true,
      }
    }

    return answer
  })

  const candidates = []
  let minOpinionDifference = 100

  for (const candidate of allCandidates[district]) {
    let opinionDifference = 0
    let score = 0
    let differentOpinions = []

    for (const answer of opinions) {
      const candidateAnswer = candidate.answers[answer.question]
      const difference = getDifference(answer.answer, candidateAnswer)

      opinionDifference += difference

      const matchingOpinion = Math.sign(answer.answer) === Math.sign(candidateAnswer)
      if (matchingOpinion) {
        const maxDifference = answer.weighted ? MAX_WEIGHTED_OPINION_DIFFERENCE : MAX_OPINION_DIFFERENCE
        if (difference <= maxDifference) {
          score++
        }
      } else if (candidateAnswer !== 0) {
        differentOpinions.push(answer.question)

        // lose score if not matching weighted answer
        if (answer.weighted) {
          score--
        }
      }
    }

    const percentage = score / opinions.length

    if (percentage <= .5) {
      continue
    }

    if (opinionDifference < minOpinionDifference) {
      minOpinionDifference = opinionDifference
    }

    const matchingPartyAlliance = districtPartyAlliances.find(alliance => alliance.includes(candidate.party))

    if (matchingPartyAlliance) {
      candidate.partyAlliance = matchingPartyAlliance.join('+')
    }

    candidates.push({
      opinionDifference,
      perfectMatch: score === opinions.length,
      percentage,
      candidate,
      differentOpinions,
    })
  }

  let filteredResults = candidates.filter(item => {
    if (filters.ageGroup && filters.ageGroup.length && !filters.ageGroup.includes(item.candidate.ageGroup)) {
      return
    }
    if (filters.gender && filters.gender.length && !filters.gender.includes(item.candidate.gender)) {
      return
    }

    return true
  })

  const partyOpinions = []

  _.uniq(filteredResults.map(result => result.candidate.party)).forEach(party => {
    if (!partyAnswers[party]) {
      return
    }

    let opinionDifference = 0

    for (const answer of opinions) {
      opinionDifference += getDifference(answer.answer, partyAnswers[party][answer.question])
    }

    partyOpinions.push([party, opinionDifference])
  })

  const parties = _.sortBy(partyOpinions, item => item[1]).map(party => party[0])

  filteredResults = filteredResults.filter(item => {
    if (filters.party && filters.party.length && !filters.party.includes(item.candidate.party)) {
      return
    }

    return true
  })

  filteredResults = _.sortBy(filteredResults, item => parties.indexOf(item.candidate.party))
  filteredResults = _.sortBy(filteredResults, item => item.opinionDifference)
  filteredResults = _.sortBy(filteredResults, item => -item.percentage)

  const perfectResultsCount = filteredResults.filter(result => result.perfectMatch).length
  const bestResultsCount = perfectResultsCount || filteredResults.filter(result => result.percentage === filteredResults[0].percentage).length

  return {
    candidates,
    parties,
    filteredResults,
    perfectResultsCount,
    bestResultsCount,
  }
}

function getDifference(a,b) {
    return Math.abs(a-b)
}